<template>
    <div class="table">
        <qx-table :data="list" @selection-change="onSelection" @sort-change="sortChange" stripe>
            <
            <template v-for="config in configs">
                <el-table-column v-if="config.prop === 'operation'" v-bind="config" :key="config.prop">
                    <template scope="scope">
                        <qx-btn @click="onClick('switch', scope.row)">{{scope.row.status === "运行中" ? '关闭' : '开启'}}</qx-btn>
                        <qx-btn @click="onClick('edit', scope.row)">编辑</qx-btn>
                    </template>
                </el-table-column>
                
                <el-table-column v-else v-bind="config" :key="config.prop" :sortable="config.sortable"></el-table-column>
            </template>
        </qx-table>
    </div>
</template>

<script>
    import QxTable from "@/components/common/qx-table";
    import QxBtn from "@/components/common/qx-btn";
    import QxLink from "@/components/common/qx-link";
    export default {
        name: "BaseTable",
        components: {QxLink, QxBtn, QxTable},
        props: {
            list:Array,
            configs:Array,
        },
        data: function () {
            return {
            }
        },
        computed: {
        },
        methods: {
            selectable: function (row) {
                return _.has(row.operation,"audit") && !_.isEmpty(row.operation.audit)
            },
            operations: function (op) {
                if(_.has(op,"audit") && _.isEmpty(op['audit'])) {
                   delete op.audit
                }
                return _.keys(op)
            },
            onClick: function (op,item) {
                this.$emit('operation', {name:op,item:item});
            },
            onSelection: function (val) {
                this.$emit("selection", val)
            },
            // expandType: function (item) {
            //     return _.has(item,'agencyId')?'agency':'client'
            // },
            // isImage: function (name) {
            //     return _.endsWith(name,".png")||_.endsWith(name,".jpg")
            // },
            // getImgStyle: function (event) {
            //     let image = event.target
            //     let w = image.width,h = image.height
            //     if(w>600) {
            //         h = h*(600/w)
            //         w = 600
            //     }
            //     if(h>600) {
            //         w = w*(600/h)
            //         h = 600
            //     }
            //     image.width = w
            //     image.height = h
            // },
            // downloadUrl: function (a) {
            //     return process.env.VUE_APP_QIXIAO_CRM_WEB_BASE_URL+'/download?fileName='+a.name+'&url='+a.url
            // }
            sortChange: function(column) {
                this.$emit("sortChange", column)
            }
        }
    }
</script>

<style scoped>
    .table {
        margin-top: 20px;
    }
    .table >>> .expand {
        padding-left: 47px;
    }
    .table >>> .el-table__expanded-cell {
        padding: 0;
    }
    .table >>> .expand .el-table--border {
        border-top: none;
    }
</style>
